export default __webpack_public_path__ + "static/media/group-chat-icon.8a052e24.svg";